import script from "./GenerateSubhireDocumentModal.vue?vue&type=script&setup=true&lang=js"
export * from "./GenerateSubhireDocumentModal.vue?vue&type=script&setup=true&lang=js"

import "./GenerateSubhireDocumentModal.vue?vue&type=style&index=0&id=3b09a92d&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b09a92d"]])

export default __exports__